module.exports = __webpack_public_path__ + "img/search.4ed2f41d.svg";